var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_602_4427",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_602_4427)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#1E2248"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_602_4427",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_602_4427",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAACJwAAAicBvhJUCAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAVBSURBVHic7dtrrF1DFAfw3+2tXqqiqUf1ohJpKT5pSFAkDYKKR4OU0NBISjyqgvhEpBKvhBASfKhnEa9KCNEPxKPxgS/1qHeoR+pZRXE9eu/1YfZx9jn37LPPY/a+t/SfTM7sOWtmrZm9ZmatNbMpH4fiIXyOzfgeb+BO7D8K8pSGCbgLQxjOSJuxDD2jJGOhWGFkh7/Bxgbl14+SjIVhgdoOrsSM1P+HCNOg8v8gDi5DsNiqtjuOQ29d+VLsl+QfwjlCR9PYHq9idvL8Mh6to/kbz+PbOOLGx4ey5/cwBrBTk/pH5dQfxnsFyR4FmzQX/sGc+j34OKeNTTEFHh+zsTqswO+p5424OafOME7GBehLlU/E2VGlS9DOGjAR84TFaXIGzSJsk+T78XXnotVgGtYn+b9xXwbdRrwprBMDkXgjrOJfy5+f6TQtIv9pbfJej9NjMV/SJvOxMADDgsF1cV7DeVNgtqBS45LnH/GYYMY2wjLB4qO4KfAXrsmg20vQ1inJ8yAOwppOGa9UHdF3MTWHPr0LFKUBebvAVKxN0T/RjLiZBoxPmG2bPM/B6znMN2FSkl8gaEwMTBE0D37FDjn0c7A6yQ8k9IPtMp2uOoo/qU6DZsizA2KkVuyAcYnMlTrTmxFmYUIqPyAsKnmI9cab4bsWaIbUboMTsghjG0KLcHkzhl3iD9xQUNsjMENVhWKt5mUibbfMyCJqZV7/p7F1AEZbgNFGkd4gYTG8NPm9RVjExhSKHIDt8KTgQTJGY33dDsAUwcL6ua58Ep7B3FRZ1EBGGcjbBucIKr0Jx6bKJwsmc9p6u0f5601L22A3GnCYELXpw9OCqq/FKhyYorsVV6gNgl6CC8UxmD7CuQoIlOZpwG6CW5y20euDotc2qNcruLQx/YOrGvBpSQOaoRVLcC+sayDQkPDWs7CqQZ1O04CgjfUofAoQNOAYIYbfn5QNC1vfHU3qzRPOCfqa0LQjww8R2hmBdnyB/fEFfsOZRQjTAUrRgArew97C/P4zUpulIKYhtDlJWxT+975AGQNwtKo5vEWh24BID25KtbE4nmgtodRFsB7jhG3wwlRZzDB5KcjTgH0EM/RtzEqV9+J+tcbKK6rh8rJQuAbMx8wk/yKOxJfCqXD6XO4FnKr2pPgYwX7fRvf4BNeJfBhKvgYcIBxSVGjWCZ1Nv/mnjHR4evGLxmZtp2lJA/lK8QUOVzsI6fSwbA37IKNOp2l+Ax6lLIKrcQqeVT1Cg7txkezDlCNwfF2dTvE+XovQzgi0sw3OE+bgMG40Nu75lboNPi94dzvirUhtloKYdsC6iG2Vhq2+QAk8+rFnCXw6QtEDcDY+w6c4oWBeHaHIAViMBwRDaLxgKW5RyNsGdxLu3zyoeimpgsvUXov/FHsUJmljFL4NLsJpSX6WYN//jKuF22IVfCjEBL5Klc3ESV3yr2AdHhc6GhV5GjBXOBar0KwWDkDTJuoa7FpXr0dwmmKawgsbyFeKL3Ce7C9A3tT4Zvg44TOZmAPQKNhSiiW4XLhDfLta8/cVnKjxgeiQ8E3BQuEEuVusxb0R2hmBdnyBpSna58TpWLco1Re4TXBxpwpu8BYTHo/pC7wQsa3SsNUXGG0BRhvNBiAdZJxobAQ5WkWP8BVaBb9nETZDr2DZVVbSs7qXqzQsVJX7JyM/4/sXzRbBQeG7vfOT5+XYV7i2vj6r0iijH2fgylTZIzq4Kl/BLsK5f0yrrcz0OXbutPMVzMQ7Y6Az7aZ3VA9uukafMBVewoYx0LmstCGRcbEWb6D9A8v9ytJeE+SsAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrders);
export default __webpack_public_path__ + "static/media/icon_orders.c41d85c3fda56e6ba7139048445535e1.svg";
export { ForwardRef as ReactComponent };